import type React from 'react'
import type { ReactNode } from 'react'
import type { Range } from '../../../../../Model/Order/processingProfile.js'

export const Block: React.FC<{ children: ReactNode }> = ({ children }) => (
  <section className="mt-4 p-4 break-inside-avoid">{children}</section>
)

export const Chapter: React.FC<{ children: ReactNode }> = ({ children }) => (
  <h2 className="w-4/5 mx-auto text-2xl font-bold text-green-700 mb-2">{children}</h2>
)

export const Title: React.FC<{ children: ReactNode }> = ({ children }) => (
  <h3 className="w-4/5 mx-auto text-xl font-bold text-green-700 mb-2">{children}</h3>
)

export const Step: React.FC<{ title: string; children: ReactNode }> = ({ title, children }) => (
  <div className="w-4/5 mx-auto mb-6">
    <h4 className="font-semibold text-lg text-green-800 mb-1">{title}</h4>
    {children}
  </div>
)

export const Prose: React.FC<{ children: ReactNode }> = ({ children }) => <div className="w-4/5 mx-auto mb-4">{children}</div>

export const Code: React.FC<{ children: ReactNode }> = ({ children }) => <code className="bg-gray-100 px-1">{children}</code>

export const Caveat: React.FC<{ children: ReactNode }> = ({ children }) => <p className="text-sm text-gray-600 italic">{children}</p>

export const pct = (value: number | null | undefined): string => (value == null ? 'n/a' : `${(value * 100).toFixed(2)}%`)

export const num = (value: number | null | undefined): string => (value == null ? 'n/a' : value.toLocaleString('en-US'))

export const bp = (range: Range | null): string =>
  range == null ? 'n/a' : range.min === range.max ? `${range.min}` : `${range.min}–${range.max}`
